import { CLIENT_SETTINGS, EMAIL_TEMPLATES, ALERT_SETTINGS } from '../fixtures/settings';

// Note: les actions appellent à la fois /customer-ms/api/v1/... et /customer-ms/customer-ms/api/v1/...
// (bug existant côté front, voir CLAUDE.md). On gère les deux préfixes pour ne pas bloquer le mockup.

const dual = (path) => new RegExp(`^/customer-ms(/customer-ms)?${path}$`);

export default [
  {
    method: 'GET',
    pattern: dual('/api/v1/settings/default'),
    handler: () => CLIENT_SETTINGS,
  },
  {
    method: 'PUT',
    pattern: dual('/api/v1/settings/default'),
    handler: ({ body }) => {
      if (Array.isArray(body)) {
        body.forEach((upd) => {
          const idx = CLIENT_SETTINGS.findIndex((s) => s.code === upd.code);
          if (idx >= 0) CLIENT_SETTINGS[idx] = { ...CLIENT_SETTINGS[idx], ...upd };
        });
      }
      return CLIENT_SETTINGS;
    },
  },
  // typo existante /tempalte-mail et version correcte /template-mail
  {
    method: 'GET',
    pattern: dual('/api/v1/tempalte-mail'),
    handler: () => EMAIL_TEMPLATES,
  },
  {
    method: 'GET',
    pattern: dual('/api/v1/template-mail'),
    handler: () => EMAIL_TEMPLATES,
  },
  {
    method: 'PUT',
    pattern: dual('/api/v1/template-mail'),
    handler: ({ body }) => {
      const idx = EMAIL_TEMPLATES.findIndex((t) => t.id === body.id || (t.code === body.code && t.language === body.language));
      if (idx >= 0) EMAIL_TEMPLATES[idx] = { ...EMAIL_TEMPLATES[idx], ...body };
      else EMAIL_TEMPLATES.push({ id: `tpl-${EMAIL_TEMPLATES.length + 1}`, ...body });
      return EMAIL_TEMPLATES;
    },
  },
  {
    method: 'GET',
    pattern: dual('/api/v1/settings/alert'),
    handler: () => ALERT_SETTINGS,
  },
  {
    method: 'PUT',
    pattern: dual('/api/v1/settings/alert'),
    handler: ({ body }) => {
      if (Array.isArray(body)) {
        body.forEach((upd) => {
          const idx = ALERT_SETTINGS.findIndex((s) => s.code === upd.code);
          if (idx >= 0) ALERT_SETTINGS[idx] = { ...ALERT_SETTINGS[idx], ...upd };
        });
      }
      return ALERT_SETTINGS;
    },
  },
];
